import {
  AttendanceEmployeeFiltersInput,
  BulkCreatePayrollSupplementAttendanceManualCompensationDocument,
  PayrollPolicyPeriodTypesPeriodTypeEnum,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { i18nDateToString } from 'modules/core/lib/dates'
import { handleResult } from 'modules/core/lib/handleMutation'

interface UseBulkCreatePayrollSupplementParams {
  employeeIds: string[]
  startOn: Date
  endOn: Date
  period?: PayrollPolicyPeriodTypesPeriodTypeEnum
  selectAll?: boolean
  excludedEmployeeIds?: string[]
  filters?: AttendanceEmployeeFiltersInput | null
}

export const useBulkCreatePayrollSupplement = () => {
  const [bulkCreatePayrollSupplement, { loading, error }] = useMutation(
    BulkCreatePayrollSupplementAttendanceManualCompensationDocument,
    {
      extractorFn: (data) =>
        data.attendanceMutations.bulkCreatePayrollSupplementAttendanceManualCompensation,
    }
  )

  const bulkCompensatePeriods = async (params: UseBulkCreatePayrollSupplementParams) => {
    const { employeeIds, startOn, endOn, period, selectAll, excludedEmployeeIds, filters } = params

    const payload: {
      employeeIds: string[] | null
      startOn: string
      endOn: string
      period?: PayrollPolicyPeriodTypesPeriodTypeEnum
      selectAll?: boolean
      excludedEmployeeIds?: string[]
      filters?: AttendanceEmployeeFiltersInput | null
    } = {
      employeeIds,
      startOn: i18nDateToString(startOn, 'backend'),
      endOn: i18nDateToString(endOn, 'backend'),
      period: period ?? 'next',
    }

    if (selectAll) {
      payload.employeeIds = null
      payload.excludedEmployeeIds = excludedEmployeeIds
      payload.filters = filters || null
    }

    const result = await bulkCreatePayrollSupplement({ variables: payload })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      return handled.data
    }

    return null
  }

  return {
    bulkCompensatePeriods,
    loading,
    error,
  }
}
